import axios from "axios";
import axiosRetry from "axios-retry";
import axiosOnSuccessEvent from "utils/axiosOnSuccessEvent";
import { logError, logInfo } from "utils/logger";
import removeDoubleSlashes from "utils/removeDoubleSlashes";

export interface WhoAmIResponse {
    TrackingId: string | null;
    CustomerId: string | null;
}

export default async function whoAmI(): Promise<WhoAmIResponse | undefined> {
    try {
        axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay });

        const response = await axios.post<string>(
            removeDoubleSlashes(`${process.env.NEXT_PUBLIC_MOTORPOINT_URL}/whoami`)
        );

        axiosOnSuccessEvent(response);

        const jsonData: WhoAmIResponse = JSON.parse(response.data);
        logInfo("Got whoAmI (whoAmI)", { data: response.data });
        return jsonData;
    } catch (error) {
        logError("Fetching whoAmI failed (whoAmI)", error);
    }
}
